/** Shared async chunk for small routes — see route-chunks/lightRoutes.js */
const lightRoutes = () => import('./route-chunks/lightRoutes.js')
const fromLight = (name) => () => lightRoutes().then((m) => m[name])

const accountOverviewRoute = fromLight('CsoAccountOverviewRouteStatusPage')
const consumptionOverviewRoute = fromLight('CsoConsumptionOverviewRoute')
const personalDataRoute = () => import('../components/routes/personal-data/CsoPersonalDataRoute.vue')
const tellAFriendRoute = fromLight('CsoTellAFriendProcess')
const contractAndDeliveryRoute = fromLight('CsoContractAndDeliveryOverview')
const communicationRoute = fromLight('CsoCommunicationRoute')
const tariffDetailsRoute = () => import('../components/routes/tariff-details/CsoTariffDetailsRouteStatusPage.vue')
const optinProcessRoute = fromLight('CsoOptinRouteStatusPage')
const meterReadingClosedRoute = () => import('../components/routes/meter-reading/CsoMeterReadingClosedRouteStatusPage.vue')
const bankDataRoute = () => import('../components/routes/bank-data/CsoBankDataRouteStatusPage.vue')
const partPaymentRoute = fromLight('CsoPartPaymentRouteStatusPage')
const postboxRoute = fromLight('CsoPostboxRoutePage')
const loadProfileRoute = () => import('../components/routes/load-profile/CsoLoadProfileRouteStatusPage.vue')
const dynamicTariffsRoute = () => import('../components/routes/dynamic-tariffs/CsoDynamicTariffsRouteStatusPage.vue')
const loginRoute = () => import('../components/routes/login/CsoLoginRoute.vue')
const installmentPlanRoute = () => import('../components/routes/installment-plan/CsoInstallmentPlanRouteStatusPage.vue')
const authorizedPersonRoute = fromLight('CsoAuthorizedPersonProcess')
const moveRoute = () => import('../components/routes/move/CsoMoveRouteStatusPage.vue')
const contactForm = () => import('../components/routes/contact-form/CsoContactFormRouteStatusPage.vue')
const passwordForgottenRoute = fromLight('CsoPasswordForgottenRouteStatusPage')
const changeInvoiceAddressRoute = fromLight('CsoChangeInvoiceAddressRouteStatusPage')
const einvoiceRoute = () => import('../components/routes/einvoice/CsoEinvoiceRouteStatusPage.vue')
const moveInOpenRoute = () => import('../components/routes/move-in/CsoMoveInOpenRouteStatusPage.vue')
const moveInClosedRoute = () => import('../components/routes/move-in/CsoMoveInClosedRouteStatusPage.vue')
const signUpRoute = fromLight('CsoSignUpRouteStatusPage')
const addBusinessPartner = fromLight('CsoBusinessPartnerPage')
const tariffChangeRoute = fromLight('CsoTariffChangeRouteStatusPage')
const deregisterRoute = fromLight('CsoDeregisterPage')
const deregisterSentPage = fromLight('CsoDeregisterSentRoute')
const genericPageRoute = () => import('../components/routes/generic-page/CsoGenericPageRoute.vue')
const digitalInterfaceDashboard = () => import('../components/routes/digital-interface-dashboard/CsoDiDashboardRoute.vue')
const tokenOverviewPage = fromLight('CsoTokenOverviewPage')
const cso404Route = fromLight('Cso404Route')

export default class CsoRouter {
  static router

  static isOpenArea

  static di

  static routes = [
    {
      path: '/404',
      name: '404',
      components: {
        default: cso404Route,
        openarea: cso404Route
      }
    },
    {
      path: '/registrierung',
      name: 'signUp',
      meta: {
        seoKey: 'REGISTRIERUNG',
        loginForbidden: true,
        robotsFollow: true
      },
      components: {
        openarea: signUpRoute
      }
    },
    {
      path: '/kontostandinformationen',
      name: 'accountOverview',
      meta: {
        seoKey: 'KONTOSTAND',
        loginRequired: true
      },
      components: {
        default: accountOverviewRoute
      }
    },
    {
      path: '/verbrauch',
      name: 'consumptionOverview',
      meta: {
        seoKey: 'VERBRAUCH',
        loginRequired: true,
        usingSubscription: true
      },
      components: {
        default: consumptionOverviewRoute
      }
    },
    {
      path: '/benutzerprofil',
      name: 'personalData',
      meta: {
        seoKey: 'PERSOENLICHE_DATEN',
        loginRequired: true
      },
      components: {
        default: personalDataRoute
      }
    },
    {
      path: '/freundewerben',
      name: 'tellAFriend',
      meta: {
        seoKey: 'FREUNDE_WERBEN',
        loginRequired: true
      },
      components: {
        default: tellAFriendRoute
      }
    },
    {
      path: '/vertragskonto',
      name: 'dashboard',
      meta: {
        seoKey: 'DASHBOARD',
        loginRequired: true,
        usingSubscription: true
      },
      components: {
        default: digitalInterfaceDashboard
      }
    },
    {
      path: '/lieferstelle',
      name: 'deliveryAndContract',
      meta: {
        seoKey: 'LIEFERSTELLE',
        loginRequired: true
      },
      components: {
        default: contractAndDeliveryRoute
      }
    },
    {
      path: '/kommunikation',
      name: 'communication',
      meta: {
        seoKey: 'ONLINE_KOMMUNIKATION',
        loginRequired: true
      },
      components: {
        default: communicationRoute
      }
    },
    {
      path: '/tarifdetails',
      name: 'tariffDetails',
      meta: {
        seoKey: 'TARIFDETAILS',
        loginRequired: true
      },
      components: {
        default: tariffDetailsRoute
      }
    },
    {
      path: '/produktwechsel',
      name: 'tariffChange',
      meta: {
        seoKey: 'PRODUKTWECHSEL',
        loginRequired: true
      },
      components: {
        default: tariffChangeRoute
      }
    },
    {
      path: '/werbeeinverstaendnis',
      name: 'optin process',
      meta: {
        seoKey: 'OPT',
        loginRequired: true
      },
      components: {
        default: optinProcessRoute
      }
    },
    {
      path: '/zaehler',
      name: 'meter reading closed process',
      meta: {
        seoKey: 'ZAEHLERSTAND',
        loginRequired: true
      },
      components: {
        default: meterReadingClosedRoute
      }
    },
    {
      path: '/bankdaten',
      name: 'bank data',
      meta: {
        seoKey: 'EZE',
        loginRequired: true
      },
      components: {
        default: bankDataRoute
      }
    },
    {
      path: '/abschlag',
      name: 'part payment',
      meta: {
        seoKey: 'ABSCHLAG',
        loginRequired: true
      },
      components: {
        default: partPaymentRoute
      }
    },
    {
      path: '/postfach',
      name: 'postbox',
      meta: {
        seoKey: 'POSTFACH',
        loginRequired: true
      },
      components: {
        default: postboxRoute
      }
    },
    {
      path: '/login/:deepLink?',
      name: 'login',
      meta: {
        seoKey: 'LOGIN',
        loginForbidden: true,
        robotsFollow: true
      },
      components: {
        openarea: loginRoute
      }
    },
    {
      path: '/lastgang',
      name: 'load profile',
      meta: {
        seoKey: 'LASTGANG',
        loginRequired: true
      },
      components: {
        default: loadProfileRoute
      }
    },
    {
      path: '/dynamischertarif',
      name: 'dynamic tariffs',
      meta: {
        seoKey: 'LASTGANG',
        loginRequired: true
      },
      components: {
        default: dynamicTariffsRoute
      }
    },
    {
      path: '/ratenplan',
      name: 'installment plan',
      meta: {
        seoKey: 'RATENPLAN',
        loginRequired: true
      },
      components: {
        default: installmentPlanRoute
      }
    },
    {
      path: '/vollmacht',
      name: 'authorized person',
      meta: {
        seoKey: 'VOLLMACHT',
        loginRequired: true
      },
      components: {
        default: authorizedPersonRoute
      }
    },
    {
      path: '/umzug',
      name: 'move',
      meta: {
        seoKey: 'UMZUG',
        loginRequired: true
      },
      components: {
        default: moveRoute
      }
    },
    {
      path: '/kontakt',
      name: 'contact-form',
      meta: {
        seoKey: 'KONTAKT'
      },
      components: {
        default: contactForm,
        openarea: contactForm
      }
    },
    {
      path: '/neuespasswort',
      name: 'password forgotten',
      meta: {
        seoKey: 'PASSWORT_VERGESSEN',
        loginForbidden: true,
        robotsFollow: true
      },
      components: {
        openarea: passwordForgottenRoute
      }
    },
    {
      path: '/rechnungsadresseaendern',
      name: 'change invoice address',
      meta: {
        seoKey: 'RECHNUNGSADRESSEAENDERN',
        loginRequired: true
      },
      components: {
        default: changeInvoiceAddressRoute
      }
    },
    {
      path: '/bestellung',
      name: 'move in open',
      meta: {
        seoKey: 'EINZUG',
        simpleHeaderAndFooter: true
      },
      components: {
        openarea: moveInOpenRoute
      }
    },
    {
      path: '/einzug',
      name: 'move in closed',
      meta: {
        seoKey: 'EINZUG',
        loginRequired: true
      },
      components: {
        default: moveInClosedRoute
      }
    },
    {
      path: '/erechnung',
      name: 'einvoice',
      meta: {
        seoKey: 'ERECHNUNG',
        loginRequired: true
      },
      components: {
        default: einvoiceRoute
      }
    },
    {
      path: '/weiteresvertragskonto',
      name: 'addBusinessPartner',
      meta: {
        seoKey: 'VERTRAG_ZUORDNEN',
        loginRequired: true
      },
      components: {
        default: addBusinessPartner
      }
    },
    {
      path: '/deregistrierung',
      name: 'deregister',
      meta: {
        seoKey: 'DEREGISTRIERUNG'
      },
      components: {
        openarea: deregisterSentPage,
        default: deregisterRoute
      }
    },
    {
      path: '/geraeteverwaltung',
      name: 'tokenOverview',
      meta: {
        seoKey: 'GERAETEVERWALTUNG',
        loginRequired: true
      },
      components: {
        default: tokenOverviewPage
      }
    },
    {
      path: '/online',
      name: 'genericPage',
      meta: {
        seoKey: '',
        simpleHeaderAndFooter: true,
        loginForbidden: true
      },
      components: {
        openarea: genericPageRoute
      }
    },
    {
      path: '/kuendigen|impressum',
      name: 'vfde',
      beforeEnter: (to) => {
        location.href = `//vattenfall.de/${to.path}`
        return false
      }
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/service',
      redirect: '/login'
    },
    {
      path: '/:all(.*)',
      redirect: '/404'
    }
  ]

  static setRouterObject (router) {
    this.router = router
  }

  static setDiObject (di) {
    this.di = di
  }

  static parseQueryString (url) {
    let parts = url.split('?')
    let query = {}
    if (parts[1]) {
      let params = parts[1].split('&')
      for (const param of params) {
        let paramParts = param.split('=')
        query[paramParts[0]] = paramParts[1]
      }
    }
    return { base: parts[0], query }
  }

  static findInRoutes (url) {
    if (!url || url == '/') {
      return false
    }
    let urlData = this.parseQueryString(url)
    let foundRoute = this.routes.find(needle => {
      let path = needle.path.split('?')[0].replace('/:deepLink', '')
      return path === urlData.base
    })
    if (!foundRoute) {
      return false
    }
    if (urlData.query) {
      foundRoute.query = urlData.query
    }
    return foundRoute
  }

  static redirectToSessionLostLoginPage () {
    this.isOpenArea = true
    this.router.push({ name: 'login', query: { sessionLost: 'true' } })
  }

  static async checkPostfachLoginForceLogout (to) {
    if (to.name !== 'login' || to.params?.deepLink !== 'postfach') {
      return
    }
    const { default: Authentication } = await import('@/common/Authentication')
    await Authentication.forceLogoutForPostfachLogin()
  }

  static checkIfLoginRequired (to) {
    const isAnonymous = !this.di.token || this.di.token.isAnonymous()
    if (to.meta.loginRequired && isAnonymous) {
      this.isOpenArea = true
      const deepLink = to.path.slice(1)
      return { name: 'login', params: { deepLink } }
    }
  }

  static checkIfLoginForbidden (to) {
    const isAnonymous = !this.di.token || this.di.token.isAnonymous()
    if (to.meta.loginForbidden && !isAnonymous) {
      this.isOpenArea = false
      return { name: 'dashboard' }
    }
  }

  static async checkIfLoginTemporary () {
    const tmp = this.di.token?.isBusinessPartner() || this.di.token?.isContractAccount()
    if (tmp) {
      await this.di.v14.deauthenticate()
      await this.di.v14.authenticateAnonymous()
    }
  }

  static focusOnHeader () {
    document.querySelector('.cso-header .logo')?.focus()
  }
}

export {
  accountOverviewRoute,
  consumptionOverviewRoute,
  personalDataRoute,
  tellAFriendRoute,
  contractAndDeliveryRoute,
  communicationRoute,
  tariffDetailsRoute,
  optinProcessRoute,
  meterReadingClosedRoute,
  bankDataRoute,
  partPaymentRoute,
  postboxRoute,
  loadProfileRoute,
  dynamicTariffsRoute,
  loginRoute,
  installmentPlanRoute,
  authorizedPersonRoute,
  moveRoute,
  contactForm,
  passwordForgottenRoute,
  changeInvoiceAddressRoute,
  einvoiceRoute,
  moveInOpenRoute,
  moveInClosedRoute,
  signUpRoute,
  addBusinessPartner,
  tariffChangeRoute,
  deregisterRoute,
  deregisterSentPage,
  genericPageRoute,
  digitalInterfaceDashboard,
  tokenOverviewPage,
  cso404Route
}
